import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getKeyHandler } from '../structure/FlowForm';
import './FocusBlock.css';
const FocusBlock = ({ children, onClick, onFocus, onBlur, focusVisible = true, focussable = 'flow', className = '', keyOverride, keyHandler, disabled }) => {
    const [clicked, setClicked] = React.useState(false);
    const click = () => {
        setClicked(true);
        setTimeout(() => setClicked(false), 200);
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    const handleKeyDown = getKeyHandler({
        enterBehaviour: 'action',
        spaceBehaviour: 'action',
        sidewaysBehaviour: 'both',
        onAction: () => click(),
        overrideHandlers: keyOverride,
        defaultHandler: keyHandler,
    });
    return (_jsx("div", { className: `focusBlock ${className !== null && className !== void 0 ? className : ''} ${focussable == 'flow' && !disabled ? 'flowFocussable' : (focussable == 'sideway' && !disabled ? 'flowFocussable sidewayFocus' : '')} ${clicked ? 'clicked' : 'unclicked'}${focusVisible ? '' : ' focusInvisible'}`, tabIndex: disabled ? undefined : 0, onClick: (ev) => { ev.preventDefault(); ev.stopPropagation(); click(); }, onFocus: onFocus, onBlur: onBlur, onKeyDown: handleKeyDown, children: children }));
};
export default FocusBlock;
